export default __webpack_public_path__ + "static/media/Strugani 19.78a848fe.jpg";